module.exports = __webpack_public_path__ + "static/media/up-chevron.3a493887.svg";